import { jsx as _jsx } from "react/jsx-runtime";
const React = require("react");
import { Link as SharedLink } from "../../../../Shared/components/Link";
export const Link = (props)=>/*#__PURE__*/ _jsx(SharedLink, {
        defaultClassName: "",
        ...props
    });
